import React from "react";
import { ArrowUpRight } from "lucide-react";
import "../sass/landing/voice.scss";
import Shot from "./landing/Shot";
import { IMAGES } from "./landing/images";

const ANDRESA_INSTAGRAM = "https://www.instagram.com/andresamagalhaespsi/";

const Testimonial = () => (
  <section className="lp-voice" aria-label="Depoimento de quem usa o PsyAssist">
    <div className="lp-shell lp-voice__grid">
      <figure className="lp-voice__portrait" data-reveal="mask">
        <Shot
          image={IMAGES.andresa}
          sizes="(min-width: 1024px) 420px, 60vw"
          alt="Andresa, psicóloga, sentada em uma poltrona clara, sorrindo."
        />
        <figcaption className="lp-voice__portrait-note">Na rotina de quem atende.</figcaption>
      </figure>

      <div className="lp-voice__content">
        <p className="lp-voice__eyebrow">Quem usa, conta</p>
        <blockquote className="lp-voice__quote">
          <p>
            O sistema otimizou muito a minha rotina. Hoje consigo centralizar
            em um só lugar prontuários, anamnese, evolução, confirmação e
            cobrança das sessões, pagamentos, leads e relatórios.
          </p>
          <p>
            Isso me poupa tempo, organiza minha rotina e deixa a gestão muito
            mais prática.
          </p>
        </blockquote>

        <footer className="lp-voice__author">
          <strong>Andresa</strong>
          <span>Psicóloga, usa o PsyAssist no próprio dia a dia</span>
          <a
            href={ANDRESA_INSTAGRAM}
            target="_blank"
            rel="noopener noreferrer"
            className="lp-link"
          >
            Perfil profissional no Instagram
            <ArrowUpRight size={15} aria-hidden="true" />
          </a>
        </footer>
      </div>
    </div>
  </section>
);

export default Testimonial;
